{
  "visitorManagement": {
    "title": "Visitor Management",
    "description": "View and manage visitor vendor synchronization states",
    "filters": {
      "bookingId": "Booking ID",
      "vendor": "Vendor",
      "syncStatus": "Sync Status",
      "all": "All",
      "synced": "Synced",
      "failed": "Failed",
      "unknown": "Unknown",
      "search": "Search by contact name"
    },
    "table": {
      "bookingId": "Booking ID",
      "contact": "Contact",
      "dates": "Dates",
      "status": "Status",
      "note": "Note",
      "bookingDetails": "Booking Details",
      "vendor": "Vendor",
      "syncStatus": "Sync Status",
      "actions": "Actions",
      "forceSync": "Force Sync",
      "viewDetails": "View Details",
      "noData": "No visitor vendor states found",
      "loading": "Loading...",
      "validation": "Validation",
      "mirror": "Mirror",
      "lastSync": "Last Sync"
    },
    "status": {
      "synced": "Synced",
      "failed": "Failed",
      "unknown": "Unknown",
      "registered": "Registered",
      "notRegistered": "Not Registered"
    },
    "detail": {
      "title": "Vendor Sync Details",
      "syncDetails": "Sync Details",
      "vendor": "Vendor",
      "syncStatus": "Sync Status",
      "lastContacted": "Last Contacted",
      "lastSuccessful": "Last Successful Sync",
      "lastFailed": "Last Failed Sync",
      "errorMessage": "Error Message",
      "lastSuccessfulRequest": "Last Successful Request",
      "lastSuccessfulResponse": "Last Successful Response",
      "lastFailedRequest": "Last Failed Request",
      "lastFailedResponse": "Last Failed Response",
      "never": "Never",
      "close": "Close",
      "forceSyncTooltip": "Force sync feature coming soon"
    },
    "empty": {
      "noStates": {
        "title": "No Vendor States",
        "description": "No bookings have been synced with visitor management vendors yet."
      },
      "noResults": {
        "title": "No Results Found",
        "description": "Try adjusting your filters to find what you're looking for."
      },
      "noPermission": {
        "title": "Access Denied",
        "description": "You don't have permission to view visitor management data. Please contact your administrator."
      }
    },
    "error": {
      "title": "Error loading visitor vendor states",
      "description": "Failed to load visitor vendor states. Please try again."
    },
    "bookingTab": {
      "title": "Visitor Management",
      "vendorIntegrations": "Vendor Integrations",
      "noVendors": "No vendor integrations configured for this booking",
      "noVendorsConfigured": "No vendors configured",
      "error": "Unable to load visitor management data",
      "neverSynced": {
        "title": "Never Synced",
        "description": "This booking has not been synchronized with vendor systems yet."
      }
    }
  }
}
